// src//OrderRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import OrderList from "./OrderList";
import OrderDetails from "./OrderDetails";
import OrderForm from "./OrderForm/OrderForm";
import RefundApproval from "./RefundApproval";
import RefundProcessing from "./RefundProcessing";

const OrderRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<OrderList />} />
      <Route path="/new" element={<OrderForm mode="add" />} />
      <Route path="/:orderId" element={<OrderDetails />} />
      <Route path="/edit/:orderId" element={<OrderForm mode="edit" />} />
      <Route path="/edit/:orderId" element={<OrderForm mode="edit" />} />
      <Route path="/:orderId/refund/approve" element={<RefundApproval />} />
      <Route path="/:orderId/refund/process" element={<RefundProcessing />} />
    </Routes>
  );
};

export default OrderRoutes;
